import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { newsEntriesDelete } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteNewsEntry = (
  id: number,
  options: UseMutationOptions<void, unknown, void, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => extractData(newsEntriesDelete({ path: { id } })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['newsEntries'],
      });
      options.onSuccess?.(...args);
    },
  });
};
